window.App = {
    W: $(window),
    D: $(document),
    H: $('html'),
    B: $('body')
};